import TweenLite from 'gsap/TweenLite'
import { Power4 } from 'gsap/EasePack'

import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-sound-manager',

    mixins: [
        AppComponent
    ],

    props: {
        isMuted: { type: Boolean, default: false }
    },

    data() {
        return {
            sounds: [
                {
                    id: 'ambient',
                    src: '/static/sounds/ambient.mp3',
                    volume: 0.5,
                    loop: true
                },
                {
                    id: 'tinkle_1',
                    src: '/static/sounds/tinkle_1.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_2',
                    src: '/static/sounds/tinkle_2.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_3',
                    src: '/static/sounds/tinkle_3.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_4',
                    src: '/static/sounds/tinkle_4.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_5',
                    src: '/static/sounds/tinkle_5.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_6',
                    src: '/static/sounds/tinkle_6.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_7',
                    src: '/static/sounds/tinkle_7.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_8',
                    src: '/static/sounds/tinkle_8.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_9',
                    src: '/static/sounds/tinkle_9.mp3',
                    volume: 0.4,
                    loop: false
                },
                {
                    id: 'tinkle_10',
                    src: '/static/sounds/tinkle_10.mp3',
                    volume: 0.4,
                    loop: false
                }
            ]
        }
    },

    watch: {
        isMuted: 'onMutedChange'
    },

    created() {
        this.eventHub.$on('app-sound-manager:play', this.onPlay)
        this.eventHub.$on('app-sound-manager:pause', this.onPause)
        this.eventHub.$on('app-sound-manager:back-to-start', this.onBackToStart)
        this.eventHub.$on('app-sound-manager:mute', this.onMute)
        this.eventHub.$on('app-sound-manager:unmute', this.onUnmute)
    },

    mounted() {
        this.$players = this.$el.querySelectorAll('.js-player')

        this.$players.forEach((player, index) => {
            player.volume = this.sounds[index].volume
            
            if (this.isMuted) {
                player.pause()
            }
        })
    },

    destroyed() {
        this.eventHub.$off('app-sound-manager:play', this.onPlay)
        this.eventHub.$off('app-sound-manager:pause', this.onPause)
        this.eventHub.$off('app-sound-manager:back-to-start', this.onBackToStart)
        this.eventHub.$off('app-sound-manager:mute', this.onMute)
        this.eventHub.$off('app-sound-manager:unmute', this.onUnmute)
    },

    methods: {
        onPlay(id) {
            this.$players.forEach(player => {
                if (player.getAttribute('data-id') === id) {
                    if (!this.isMuted) {
                        player.play()
                    }
                }
            })
        },

        onPause(id) {
            this.$players.forEach(player => {
                if (player.getAttribute('data-id') === id) {
                    player.pause()
                }
            })
        },

        onBackToStart(id) {
            this.$players.forEach(player => {
                if (player.getAttribute('data-id') === id) {
                    player.currentTime = 0
                }
            })
        },

        onMute(id) {
            this.$players.forEach(player => {
                if (player.getAttribute('data-id') === id) {
                    TweenLite.to(player, 1, { volume: 0, ease: Power4.easeOut })
                }
            })
        },

        onUnmute(id) {
            console.log('onUnmute', 'id', id)
            this.$players.forEach((player) => {
                if (player.getAttribute('data-id') === id) {
                    TweenLite.to(player, 1, { volume: 1, ease: Power4.easeIn })
                }
            })
        },

        onMutedChange() {
            this.$players.forEach(player => {
                if (this.isMuted) {
                    player.pause()
                } else {
                    player.play()
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-sound-manager/script.js